import clsx from "clsx";
import React, { DetailedHTMLProps, FC, HTMLAttributes } from "react";

import { Icon } from "../../icon";

export interface SearchResultItemCardProps
  extends Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "className"> {
  title: string;
  snippet: string;
  url: string;
  ctaLabel?: string | null;
}

export const SearchResultItemCard: FC<SearchResultItemCardProps> = ({
  title,
  snippet,
  url,
  className,
  ctaLabel,
}) => {
  return (
    <div className={clsx("flex flex-col gap-4", className)}>
      <div
        className="font-medium text-primary text-3xl"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <div
        className="font-light text-dark text-lg leading-snug"
        dangerouslySetInnerHTML={{ __html: snippet }}
      />
      <a href={url} className="flex flex-row items-center gap-2 text-primary">
        <div className="font-medium text-lg leading-snug">{ctaLabel}</div>
        <Icon icon="arrow-right" size={20} />
      </a>
    </div>
  );
};
